export default {
      id: "thumbnails-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#thumbnails",
      toString: function () {
        return this.url;
      }
    }